'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _Input = require('../../Input');

var _Input2 = _interopRequireDefault(_Input);

var _style = require('../style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Main.__proto__ || Object.getPrototypeOf(Main)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            focus: false
        }, _this._handleFocus = function (event) {
            _this.setState({ focus: true });

            if (typeof _this.props.onFocus === 'function') {
                _this.props.onFocus(event);
            }

            return _this;
        }, _this._handleBlur = function (event) {
            _this.setState({ focus: false });

            if (typeof _this.props.onBlur === 'function') {
                _this.props.onBlur(event);
            }

            return _this;
        }, _this.clear = function () {
            if (_this.input) {
                _this.input.value = '';
            }

            return _this;
        }, _this._inputRef = function (el) {
            if (typeof _this.props.elementRef === 'function') {
                _this.props.elementRef(el);
            }

            _this.input = el;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$theme = _props.theme,
                theme = _props$theme === undefined ? {} : _props$theme,
                value = _props.value,
                showClear = _props.showClear,
                _props$style = _props.style,
                style = _props$style === undefined ? {} : _props$style,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                palette = theme.palette,
                classList = this.compileStyle(_style2.default);


            style = Object.assign({}, style, {
                paddingLeft: palette.gutter * 4 + 'px',
                paddingRight: palette.gutter * 4 + 'px',
                width: '100%'
            });

            return _react2.default.createElement(
                'div',
                { className: classList.root + ' ' + className },
                _react2.default.createElement(
                    'div',
                    { className: classList.wrapper },
                    _react2.default.createElement('div', { className: classList.search }),
                    _react2.default.createElement(_Input2.default, _extends({}, this.props, {
                        style: style,
                        theme: null,
                        className: '',
                        onFocus: this._handleFocus,
                        onBlur: this._handleBlur,
                        elementRef: this._inputRef
                    })),
                    value && showClear ? _react2.default.createElement('div', { className: classList.clear, onClick: this.clear }) : null
                )
            );
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return String(this.state.focus);
        }
    }]);

    return Main;
}(_Component3.default);

Main.defaultProps = {
    showClear: true
};
Main.propTypes = {
    showClear: _propTypes2.default.bool
};
Main.displayName = 'SearchInput';
exports.default = Main;